import axios from 'axios'
import { BUSCAR_EMISSAO_CTE_OS_NOTA_FISCAL } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function buscarEmissaoCteOSNotaFiscal (id, empresaId) {

  const url = `${URL}/emissao-cte-os/${id}/empresa/${empresaId}/nota-fiscal`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_EMISSAO_CTE_OS_NOTA_FISCAL,
        payload: response

      })
  );
}
